export default __webpack_public_path__ + "static/media/topbanner_Element_Img.0af6049c.svg";